import React from "react";
import { Card } from "react-bootstrap";

const MultipleChoice = ({ question, values, setValues }) => {
  const [selected, setSelected] = React.useState([]);
  const handleClick = (q, v, t) => {
    const sv = [...values];

    const existingObject = sv.find((item) => item?.code === q);

    if (existingObject) {
      if (existingObject.value.includes(v)) {
        existingObject.value = existingObject.value.filter((x) => x != v);
        existingObject.remarks = existingObject.remarks.split(" || ");
        existingObject.remarks = existingObject.remarks.filter((x) => x != t);
      } else {
        existingObject.value = [...existingObject.value, v];
        existingObject.remarks = existingObject.remarks.split(" || ");
        existingObject.remarks = [...existingObject.remarks, t];
      }
      existingObject.remarks = existingObject.remarks.join(" || ");
    } else {
      sv.push({ code: q, value: [v], remarks: t });
    }
    setValues(sv);
  };

  return (
    <Card className="mb-4 multipleChoice">
      <Card.Header>{question.name}</Card.Header>
      <Card.Body>
        {question.answers &&
          question.answers.length > 0 &&
          question.answers.map((answer) => (
            <div className="form-check d-flex gap-2 align-items-center" key={answer.code}>
              <input
                style={{ minHeight: "1.5rem", minWidth: "1.5rem" }}
                className="form-check-input"
                type="checkbox"
                id={`${question.code}_${answer.code}`}
                checked={values?.[question.code]?.value.includes(answer.code)}
                name={question.code}
                value={answer.code}
                required={question.isRequired}
                onChange={() => handleClick(question.code, answer.code, answer.name)}
              />
              <label
                style={{ textAlign: "start" }}
                className="form-check-label"
                htmlFor={`${question.code}_${answer.code}`}
              >
                {answer.name}
              </label>
            </div>
          ))}
      </Card.Body>
    </Card>
  );
};

export default MultipleChoice;
